import { ChevronRightMedium as IconComponent } from '@adobe/react-spectrum-ui/dist/ChevronRightMedium.js';
import { UIIcon } from '@react-spectrum/icon';
import React from 'react';
export default function ChevronRightMedium(props) {
  return /*#__PURE__*/React.createElement(UIIcon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}